import Box from '@mui/material/Box'
import FormControl from '@mui/material/FormControl'
import { isWidthUp } from '@mui/material/Hidden/withWidth'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import TextField from '@mui/material/TextField'
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { observer } from 'mobx-react'
import moment from 'moment'
import 'moment/locale/ru'
import React from 'react'
import calendarBlack from '../../assets/images/common/calendar-black.svg'
import lupe from '../../assets/images/common/lupe.svg'
import selectArrow from '../../assets/images/common/selectArrow.svg'
import FormInput from '../customElements/FormInput'
import MultipleSelect from '../customElements/MultipleSelect/MultipleSelect'

function FormFilter({
  data: {
    type,
    name,
    propName,
    collection,
    setMenuItem,
    placeholder,
    multiple,
    minDate,
    maxDate,
    settings,
    visible,
    mb,
    variant,
    defaultMonth,
    containerStyles,
    disabled,
    onlyNumbers,
    maxLength,
    isFrom,
    withDefaultMonth,
  },
  filtersStore,
  setChip,
  opened,
  selectsOpen,
  setSelectsOpen,
  width,
  data,
}) {
  const [dateError, setDateError] = React.useState(false)
  const setSelectArrow = (e) => (
    <img className={e.className} alt={''} src={selectArrow} />
  )
  const value = filtersStore.data?.[propName]

  if (propName === 'reasonId') {
    collection.map((item) => {
      if (item.key === 'Замена') {
        return (item.key = item.key + ' (Горыныч)')
      }
      return item
    })
  }

  const formDefaultMonth = withDefaultMonth
    ? isFrom
      ? minDate
      : maxDate
    : undefined

  return (
    <Box mb={isWidthUp('sm', width) ? mb : null} width={'100%'}>
      {type === 'date' && (
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <DesktopDatePicker
            leftArrowButtonText={'Предыдущий месяц'}
            rightArrowButtonText={'Следующий месяц'}
            defaultCalendarMonth={defaultMonth || formDefaultMonth}
            minDate={minDate && minDate}
            maxDate={maxDate && maxDate}
            renderInput={({ inputProps, ...props }) => {
              return (
                <TextField
                  placeholder={'ДД.MM.ГГГГ'}
                  fullWidth={true}
                  onBlur={() => {
                    if (dateError) {
                      filtersStore.data[propName] = null
                      setDateError(false)
                    }
                  }}
                  onKeyDown={(event) => {
                    if (event.key === 'Enter' && dateError) {
                      event.preventDefault()
                      event.stopPropagation()
                    }
                  }}
                  {...props}
                  {...inputProps}
                />
              )
            }}
            onError={(e) => {
              setDateError(!!e)
            }}
            value={value}
            onChange={(newValue) => {
              filtersStore.data[propName] = newValue ? moment(newValue) : null
            }}
            label={name}
            inputFormat={'DD.MM.YYYY'}
            components={{
              OpenPickerIcon: () => (
                <img alt={'calendar icon'} src={calendarBlack} />
              ),
            }}
          />
        </LocalizationProvider>
      )}
      {type === 'select' &&
        (multiple ? (
          <MultipleSelect
            value={value}
            onChange={(event) => {
              filtersStore.onChangeMultiple(event)
            }}
            onClear={() => {
              filtersStore.onClearMultiple(propName)
            }}
            items={collection}
            propName={propName}
            label={name}
            renderValue={(value) => (
              <Box
                sx={{
                  maxWidth: '100%',
                  display: 'flex',
                  flexWrap: 'wrap',

                  gap: '1px',
                  overflow: 'hidden',
                }}
              >
                {value.map((multiselectValue) => (
                  <Box key={propName + multiselectValue}>
                    {setChip
                      ? setChip({ propName, value: multiselectValue })
                      : value}
                  </Box>
                ))}
              </Box>
            )}
            placeholder={placeholder}
            IconComponent={setSelectArrow}
            SelectDisplayProps={{
              onKeyDown: () => {},
            }}
            opened={opened}
            selectsOpen={selectsOpen}
            setSelectsOpen={setSelectsOpen}
            disabled={disabled}
          >
            {setMenuItem ? collection.map((el) => setMenuItem(el)) : null}
          </MultipleSelect>
        ) : (
          <FormControl disabled={disabled} fullWidth>
            <InputLabel disabled={disabled}>{name}</InputLabel>
            <Select
              value={value}
              label={name}
              fullWidth
              disabled={disabled}
              IconComponent={disabled ? null : setSelectArrow}
              renderValue={(value) => (
                <Box sx={{ maxWidth: '100%', overflow: 'hidden' }}>
                  {setChip ? setChip({ propName, value }) : value}
                </Box>
              )}
              onChange={(event) => {
                filtersStore.data[propName] = event.target.value
              }}
              SelectDisplayProps={{
                onKeyDown: () => {},
              }}
            >
              {collection.map((el) => {
                return setMenuItem ? (
                  setMenuItem(el)
                ) : (
                  <MenuItem value={el} key={el}>
                    {el}
                  </MenuItem>
                )
              })}
            </Select>
          </FormControl>
        ))}
      {type !== 'date' && type !== 'select' && (
        <FormInput
          type={type}
          api={filtersStore}
          propName={propName}
          label={name}
          fullWidth
          placeholder={placeholder}
          settings={settings}
          visible={visible}
          variant={variant}
          territorySelect={data?.territorySelect}
          InputProps={{
            endAdornment: !data?.disableAdornment && (
              <img alt={''} src={lupe} />
            ),
          }}
          containerStyles={containerStyles}
          autocompleteOptions={data?.autocompleteOptions}
          defaultValue={data?.defaultValue}
          disabled={data?.disabled}
          items={data?.items}
          mask={data?.mask}
          multiline={data?.multiline}
          onChange={data?.onChange}
          onPaste={data?.onPaste}
          readOnly={data?.readOnly}
          styles={data?.styles}
          withoutErrorText={data?.withoutErrorText}
          offError={data?.offError}
          onlyNumbers={onlyNumbers}
          icon={data?.icon}
          maxLength={maxLength}
        />
      )}
    </Box>
  )
}

export default observer(FormFilter)
